module.exports = __webpack_public_path__ + "img/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_HAUPTSEITE.68ed4c60.jpg";